<template>
  <vue-final-modal
    :value="value"
    name="reason-example-dialog"
    :classes="['reason-example-dialog__container']"
    :content-class="[
      'reason-example-dialog__content',
      'v--modal-box',
      'v--modal'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    @input="$emit('input', $event)"
    @opened="onOpened"
  >
    <div class="v--modal-close-top">
      <el-button
        icon="el-icon-close"
        type="text"
        @click="$emit('input', false)"
      />
    </div>
    <div class="title">例文を選ぶ</div>
    <div class="description">
      <p>選択した例文が追加されます。</p>
      <p class="attention">
        例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。
      </p>
    </div>
    <ul class="example-sentence">
      <li
        v-if="aiGeneratedExample"
        class="ai-generated-example"
        key="ai-generated"
        @click="onSelect(aiGeneratedExample)"
      >
        <div class="title">
          <span class="ai-badge">AI生成</span>
          あなた向けの提案
        </div>
        <div class="body" v-html="aiGeneratedExample"></div>
      </li>
      <li
        v-for="(item, idx) in items"
        :key="idx"
        @click="onSelect(item.description)"
      >
        <div class="title">{{ item.title }}</div>
        <div class="body" v-html="item.description"></div>
      </li>
    </ul>
    <div class="text-right">
      <el-button @click="$emit('input', false)">閉じる</el-button>
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
import { nextTick } from 'vue'

type ReasonExampleItem = {
  title: string
  description: string
}

defineProps<{
  value: boolean
  items: ReasonExampleItem[]
  aiGeneratedExample?: string
}>()

const emit = defineEmits<{
  (e: 'input', value: boolean): void
  (e: 'select', text: string): void
}>()

function onOpened() {
  nextTick(() => {
    document
      .querySelectorAll('.reason-example-dialog__container')
      .forEach((el) => {
        ;(el as HTMLElement).scrollTop = 0
      })
  })
}

function onSelect(description: string) {
  emit('select', description.replace(/<br>/gi, '\n'))
  emit('input', false)
}
</script>

<style lang="scss">
@import '@/assets/scss/format-edit/vfm-attach-body-fixed';
@include vfm-root-fixed-when-has('.reason-example-dialog__container');

.reason-example-dialog__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.reason-example-dialog__content.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  flex: 0 1 auto;
  width: 600px;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 20px 20px 50px;
  left: 0 !important;
}

.reason-example-dialog__content .title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.75rem;
}

.reason-example-dialog__content .v--modal-close-top {
  text-align: right;
}

.reason-example-dialog__content .description .attention {
  color: #e3165c;
}

.reason-example-dialog__content .ai-generated-example {
  border: 1px solid #f4a2be;
  background: #fce8ef;
}

.reason-example-dialog__content .ai-badge {
  display: inline-block;
  margin-right: 6px;
  padding: 2px 6px;
  border-radius: 4px;
  background: #e3165c;
  color: #fff;
  font-size: 0.75rem;
}
</style>
